import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { GetAllNotifiche2023FiltersDTO, GetAllNotifiche2023ResponseData } from "./dataService/dto";
import { MonitoringNotifiche2023Service, NewMonitoringNotifiche2023Service } from "./dataService/service";

interface MonitoringNotifiche2023State {
    // FILTERS
    GetAllNotifiche2023Filters: GetAllNotifiche2023FiltersDTO
    getAllNotifiche2023Status: PromiseStatuses
    GetAllNotifiche2023Response?: GetAllNotifiche2023ResponseData[]

}

const initialState: MonitoringNotifiche2023State = {

    GetAllNotifiche2023Filters: {
        itemsPerPage: 500,
        page: 0
    },

    getAllNotifiche2023Status: 'idle',
}

export const GetAllNotifiche2023 = createAsyncThunk(
    'monitoringM24Open/GetAllNotifiche2023',
    async (filters: GetAllNotifiche2023FiltersDTO, thunkApi): Promise<GetAllNotifiche2023ResponseData[]> => {
        const monitoringNotifiche2023Service = NewMonitoringNotifiche2023Service()

        return monitoringNotifiche2023Service.GetAllNotifiche2023(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const MonitoringNotifiche2023Slice = createSlice({
    name: 'MonitoringNotifiche2023Slice/slice',
    initialState,
    reducers: {
        // FILTERS
        setGetAllNotifiche2023FiltersItemsPerPage: (state, action) => {
            state.GetAllNotifiche2023Filters.itemsPerPage = action.payload
        },
        setGetAllNotifiche2023FiltersPage: (state, action) => {
            state.GetAllNotifiche2023Filters.page = action.payload
        },
        setGetAllNotifiche2023FiltersOrder: (state, action) => {
            state.GetAllNotifiche2023Filters.order = action.payload
        },
        setGetAllNotifiche2023FiltersSort: (state, action) => {
            state.GetAllNotifiche2023Filters.sort = action.payload
        },
        setGetAllNotifiche2023HeadQuarters: (state, action) => {
            state.GetAllNotifiche2023Filters.headQuarters = action.payload
        },
        setGetAllNotifiche2023NotSuperata: (state, action) => {
            state.GetAllNotifiche2023Filters.notSuperata = action.payload
        },
        setGetAllNotifiche2023NotType: (state, action) => {
            state.GetAllNotifiche2023Filters.notType = action.payload
        },
        resetGetAllNotifiche2023Filters: (state) => {
            state.GetAllNotifiche2023Filters = {
                itemsPerPage: 500,
                page: 0
            }
        },
    },
    extraReducers(builder) {
        builder

            // GET ALL
            .addCase(GetAllNotifiche2023.pending, (state) => {
                state.getAllNotifiche2023Status = 'loading'
            })
            .addCase(GetAllNotifiche2023.fulfilled, (state, action) => {
                state.getAllNotifiche2023Status = 'successfully'
                state.GetAllNotifiche2023Response = action.payload
            })
            .addCase(GetAllNotifiche2023.rejected, (state) => {
                state.getAllNotifiche2023Status = 'failed'
            })

    },
})

export const {
    setGetAllNotifiche2023FiltersItemsPerPage,
    setGetAllNotifiche2023NotSuperata,
    setGetAllNotifiche2023NotType,
    setGetAllNotifiche2023FiltersOrder,
    setGetAllNotifiche2023FiltersPage,
    setGetAllNotifiche2023FiltersSort,
    setGetAllNotifiche2023HeadQuarters,
    resetGetAllNotifiche2023Filters
} = MonitoringNotifiche2023Slice.actions

export default MonitoringNotifiche2023Slice.reducer